export interface LocaleConfig {
  id: string;
  name: string;
  nativeName: string;
  flag?: string;
  countryCode?: string; // For SVG flag icons
  rtl?: boolean;
}

// Done so far:
// - English
// - Serbian
// - Polish
// - Czech
// - Chinese
// - Arabic
// - German
// - French
// - Spanish
// - Italian
// - Japanese
// - Korean
// - Russian
// - Croatian
// - Slovenian


// Phase I languages
export const locales: LocaleConfig[] = [
  { id: 'en', name: 'English', nativeName: 'English', flag: '🇬🇧', countryCode: 'GB' },
  { id: 'de', name: 'German', nativeName: 'Deutsch', flag: '🇩🇪', countryCode: 'DE' },
  { id: 'fr', name: 'French', nativeName: 'Français', flag: '🇫🇷', countryCode: 'FR' },
  { id: 'es', name: 'Spanish', nativeName: 'Español', flag: '🇪🇸', countryCode: 'ES' },
  { id: 'it', name: 'Italian', nativeName: 'Italiano', flag: '🇮🇹', countryCode: 'IT' },
  { id: 'ja', name: 'Japanese', nativeName: '日本語', flag: '🇯🇵', countryCode: 'JP' },
  { id: 'ko', name: 'Korean', nativeName: '한국어', flag: '🇰🇷', countryCode: 'KR' },
  { id: 'zh', name: 'Chinese', nativeName: '中文', flag: '🇨🇳', countryCode: 'CN' },
  { id: 'ar', name: 'Arabic', nativeName: 'العربية', flag: '🇸🇦', countryCode: 'SA', rtl: true },
  { id: 'ru', name: 'Russian', nativeName: 'Русский', flag: '🇷🇺', countryCode: 'RU' },
  { id: 'pl', name: 'Polish', nativeName: 'Polski', flag: '🇵🇱', countryCode: 'PL' },
  { id: 'cs', name: 'Czech', nativeName: 'Čeština', flag: '🇨🇿', countryCode: 'CZ' },
  { id: 'hr', name: 'Croatian', nativeName: 'Hrvatski', flag: '🇭🇷', countryCode: 'HR' },
  { id: 'sl', name: 'Slovenian', nativeName: 'Slovenščina', flag: '🇸🇮', countryCode: 'SI' },
  { id: 'sr', name: 'Serbian', nativeName: 'Srpski', flag: '🇷🇸', countryCode: 'RS' },
];

// Phase II
//   { id: 'nl', name: 'Dutch', nativeName: 'Nederlands', flag: '🇳🇱', countryCode: 'NL' },
//   { id: 'sv', name: 'Swedish', nativeName: 'Svenska', flag: '🇸🇪', countryCode: 'SE' },
//   { id: 'no', name: 'Norwegian', nativeName: 'Norsk', flag: '🇳🇴', countryCode: 'NO' },
//   { id: 'da', name: 'Danish', nativeName: 'Dansk', flag: '🇩🇰', countryCode: 'DK' },
//   { id: 'pt', name: 'Portuguese', nativeName: 'Português', flag: '🇵🇹', countryCode: 'PT' },
//   { id: 'sk', name: 'Slovak', nativeName: 'Slovenčina', flag: '🇸🇰', countryCode: 'SK' },
//   { id: 'bg', name: 'Bulgarian', nativeName: 'Български', flag: '🇧🇬', countryCode: 'BG' }


export function getLocaleConfig(id: string): LocaleConfig | undefined {
  return locales.find(locale => locale.id === id);
}